import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import NewBadge from './new.png';
import NewCM from './newOnlyCM.png';
import './GameIcon.css';

export const GAME_BADGES = {
  new: NewBadge,
  admin: NewCM
};

function GameIcon({ game, alt, badge }) {
  const badgeImg = badge && GAME_BADGES[badge];
  const gameImg = game && game.gameIcon;

  return (
    <div className="game-icon">
      {badgeImg && (
        <img
          className="game-icon-badge"
          src={badgeImg}
          alt={badge}
          draggable="false"
        />
      )}
      {gameImg && (
        <img
          className="game-icon-img"
          src={gameImg}
          alt={alt}
          draggable="false"
        />
      )}
      {!gameImg && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip">{alt}</Tooltip>}
        >
          <div className="game-icon-default">
            <div>
              <span>{alt}</span>
            </div>
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
}

GameIcon.propTypes = {
  game: PropTypes.object,
  alt: PropTypes.string,
  badge: PropTypes.string,
  cvOnly: PropTypes.bool
};

export default GameIcon;
